import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";
import { IconCheck, IconClock, IconWhatsApp } from "./Icons";

const WomensSection = () => {
    const { t } = useLanguage();
    return (
        <section id="women" className="scroll-mt-24 bg-tint/60 py-12 md:py-20" aria-labelledby="women-title" data-testid="women-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <div className="grid items-center gap-10 rounded-[2rem] border border-gold-500/30 bg-surface p-8 shadow-sm md:p-12 lg:grid-cols-2">
                        <div>
                            <Overline>{t.women.overline}</Overline>
                            <h2 id="women-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl">
                                {t.women.title}
                            </h2>
                            <p className="mt-4 text-base leading-relaxed text-mist md:text-lg">{t.women.text}</p>
                            <p className="mt-6 inline-flex items-center gap-2.5 rounded-full bg-gold-100 px-5 py-2.5 text-sm font-bold text-ink">
                                <IconClock className="h-4 w-4 text-gold-600" />
                                {t.women.hours}
                            </p>
                            <div className="mt-7">
                                <a
                                    href="#appointment"
                                    data-testid="women-book-cta"
                                    className="inline-flex min-h-[48px] items-center gap-2 rounded-full bg-gold-500 px-7 text-sm font-semibold text-ink shadow-[0_14px_30px_-12px_rgba(178,143,55,0.55)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold-600 active:scale-95"
                                >
                                    <IconWhatsApp className="h-4 w-4" />
                                    {t.women.cta}
                                </a>
                            </div>
                        </div>
                        <ul className="grid gap-4 sm:grid-cols-2">
                            {t.women.points.map((point, i) => (
                                <li
                                    key={point}
                                    data-testid={`women-point-${i + 1}`}
                                    className="flex items-center gap-3 rounded-2xl border border-ink/10 bg-sand p-5 text-sm font-semibold text-ink transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-gold-500/50"
                                >
                                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-pine text-gold-500">
                                        <IconCheck className="h-4 w-4" />
                                    </span>
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default WomensSection;
